// routes/QuizRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import CreateProfile from "../pages/Profile/CreateProfile";
import EditProfile from "../pages/Profile/EditProfile";
import LearningPathDetails from "../pages/LearningPathDetails";
import IdTokenClaims from "../pages/IdTokenClaims";
import UserManagerAssessmentDetails from "../pages/UserManagerAssessmentDetails";
import AssessmentHistory from "../pages/AssessmentHistory";
import Dashboard from "../pages/Dashboard";
import ProtectedRouteWithUserCheck from "./utils/ProtectedRouteWithUserCheck";

const UserRoutes = (
  <>
    <Route path="/dashboard/:user_id" element={
      <ProtectedRouteWithUserCheck>
        <Dashboard />
      </ProtectedRouteWithUserCheck>
    }></Route>
    <Route path="/create-profile" element={<CreateProfile />}></Route>
    {/* <Route path="/profile" element={<EditProfile />}></Route> */}

    <Route
      path=":user_id/learning-path/:id"
      element={
        <ProtectedRouteWithUserCheck>
          <LearningPathDetails />
        </ProtectedRouteWithUserCheck>
      }
    />
    <Route path="/users/id" element={<IdTokenClaims />} />
    <Route
      path="/user/user-assessments/:user_id"
      element={
        <ProtectedRouteWithUserCheck>
          <UserManagerAssessmentDetails />
        </ProtectedRouteWithUserCheck>
      }
    ></Route>
    <Route path="/dashboard/user/:user_id" element={
      <ProtectedRouteWithUserCheck>
        <AssessmentHistory />
      </ProtectedRouteWithUserCheck>
    }
    />
  </>
);

export default UserRoutes;
